import InfoBlock from "./info-block";
export default InfoBlock;
